import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import './Text.scss'

export const Text = ({
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  size,
  bold,
  italic,
  clickable,
  color,
  backgroundColor,
  underline,
  preline,
  nowrap,
  wordBreak,
  children,
  ...props
}) => {
  const classList = useMemo(() => {
    const list = ['x-text']

    if (bold) {
      list.push('is-bold')
    }

    if (italic) {
      list.push('is-italic')
    }

    if (clickable) {
      list.push('is-clickable')
    }

    if (underline) {
      list.push('is-underline')
    }

    if (preline) {
      list.push('is-preline')
    }

    if (nowrap) {
      list.push('is-nowrap')
    }

    if (wordBreak) {
      list.push('is-word-break-all')
    }

    return list.join(' ')
  }, [bold, clickable, italic, nowrap, preline, underline, wordBreak])

  return (
    <div
      className={classList}
      style={{
        color,
        backgroundColor,
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight,
        fontSize: size,
      }}
      {...props}
    >
      {children}
    </div>
  )
}

// Props
Text.propTypes = {
  paddingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paddingLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paddingRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  bold: PropTypes.bool,
  italic: PropTypes.bool,
  clickable: PropTypes.bool,
  underline: PropTypes.bool,
  preline: PropTypes.bool,
  nowrap: PropTypes.bool,
  wordBreak: PropTypes.bool,
  children: PropTypes.node,
}

Text.defaultProps = {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  color: '#707070',
  backgroundColor: '',
  size: 'inherit',
  bold: false,
  italic: false,
  clickable: false,
  underline: false,
  preline: false,
  nowrap: false,
  wordBreak: false,
  children: null,
}

export default Text
